import type { ObPlanId } from '../../../gql/graphql'
import { UpdateType } from '../types'

interface GetUpdateSubscriptionTypeConfigParams {
  planId: ObPlanId
  channelCount: number
  currentChannelCount: number
  isPlanDowngrade: (planId: ObPlanId) => boolean
  isPlanUpgrade: (planId: ObPlanId) => boolean
}

/**
 * Get the update subscription type config
 * This will determine the update type based on the plan id, channel count, and current channel count
 * This can be used to help determine tracking attributions and also success modal flows
 */
export const getUpdateSubscriptionTypeConfig = ({
  planId,
  channelCount,
  currentChannelCount,
  isPlanDowngrade,
  isPlanUpgrade,
}: GetUpdateSubscriptionTypeConfigParams): UpdateType => {
  // Define update type resolvers with their conditions
  const updateSubscriptionTypeResolvers = [
    {
      condition: (): boolean => isPlanDowngrade(planId),
      updateType: UpdateType.SubscriptionDowngrade,
    },
    {
      condition: (): boolean => isPlanUpgrade(planId),
      updateType: UpdateType.SubscriptionUpgrade,
    },
    {
      condition: (): boolean => channelCount > currentChannelCount,
      updateType: UpdateType.ChannelIncrease,
    },
    {
      condition: (): boolean => channelCount < currentChannelCount,
      updateType: UpdateType.ChannelDecrease,
    },
  ]

  // Find matching resolver and return its updateType, or fallback to SubscriptionUpdate
  const matchedResolver = updateSubscriptionTypeResolvers.find(
    ({ condition }) => condition(),
  )
  return matchedResolver?.updateType || UpdateType.SubscriptionUpdate
}
